// Onde o token de acesso vive: na memória da aba, e em nenhum outro lugar.
//
// Antes ele ficava no localStorage. O problema não é teórico: qualquer script
// que consiga rodar na origem do sistema — um `.svg` ou `.html` enviado como
// anexo, uma dependência do frontend comprometida — lê o localStorage e sai
// com um token válido para copiar. Em memória, o roubo exige a aba aberta e
// morre quando ela fecha.
//
// A sessão não se perde ao recarregar: o refresh token continua num cookie
// httpOnly (`jrt`), que o JavaScript não enxerga. Ao abrir a página, o
// AuthProvider troca esse cookie por um token novo — que é justamente o
// caminho que já existia.
//
// Uma aba não enxerga o token da outra, e é assim que deve ser: cada aba
// restaura o seu pelo cookie.

let tokenEmMemoria = null;

// Quem precisa saber que o token mudou (hoje, o socket, que só o verifica no
// handshake e ficaria com o antigo depois de uma renovação).
const ouvintes = new Set();

export const getToken = () => tokenEmMemoria;

export const setToken = token => {
	tokenEmMemoria = token || null;
	ouvintes.forEach(ouvinte => {
		try {
			ouvinte(tokenEmMemoria);
		} catch {
			// Um ouvinte quebrado não pode impedir os outros de saber.
		}
	});
};

export const clearToken = () => setToken(null);

export const onTokenChange = ouvinte => {
	ouvintes.add(ouvinte);
	return () => ouvintes.delete(ouvinte);
};
